import { useEffect, useState } from "react";
import { Link, useLocation, useHistory } from "react-router-dom";
//--------------------------------------------------------------------------------------------
import Resize from "src/components/common/resize";
import magnifierImg from "src/img/magnifier.png";
//import UserInfo from "src/components/main/userInfo";
import { useMyStore } from "src/components/main/mainStore";
import { 
    onlyUnique, round, numberReducer, getDatefromWeekNum0,
    weeknum, getDatefromWeekNum, getTimeStamp, 
    myAxios, MyFormData, defaultEmptyDateTime, 
    simpleStatusColorCode, MyDate, 
    restDayProjectHashKey, boolAndReducer, projectCategoryColorCode,
    weekIndexes,
    appTitle
} from "src/components/common/functions";
import Export from "./export";
//--------------------------------------------------------------------------------------------
export default function ProjectCalendar({ tabTitle }){
    const user = useMyStore(state => state.user);
    //--------------------------------------------------------------------------------------------
    const history = useHistory();
    const location = useLocation();
    //--------------------------------------------------------------------------------------------
    const [updateDateTime, setUpdateDateTime] = useState(getTimeStamp());
    const [rawData, setRawData] = useState([]);
    const [showLoading, setShowLoading] = useState(true);
    const [weeks, setWeeks] = useState([]);
    const [showHours, setShowHours] = useState(false);
    const [showTimes, setShowTimes] = useState(false);
    const [category, setCategory] = useState("All");
    const [status, setStatus] = useState("All");
    const [filterWords, setFilterWords] = useState("");
    //--------------------------------------------------------------------------------------------
    const getHours = v => {
        if(v.workLogStatus === "Created"){
            return({
                portal: 0,
                withoutTravel: 0
            });
        }
        const travelStartTime = new Date(v.travelStartTime.replace(/-/g, "/"));
        const workStartTime = new Date(v.workStartTime.replace(/-/g, "/"));
        const workEndTime = new Date(v.workEndTime.replace(/-/g, "/"));
        const travelEndTime = new Date(v.travelEndTime.replace(/-/g, "/"));
        const workHours = (workEndTime - workStartTime) / 3600000;
        const travel = (travelEndTime - travelStartTime) / 3600000;
        if(travelEndTime.toString() === "Invalid Date"){
            return({
                portal: "Invalid Date",
                withoutTravel: "Invalid Date"
            });
        }
        return({
            portal: round(travel, 2),
            withoutTravel: round(workHours, 2),
        })
    }
    //--------------------------------------------------------------------------------------------
    const week = location.pathname.split("/")[2];
    const departments = Object.keys(projectCategoryColorCode);
    const filteredData0 = rawData
    .map(raw => ({...raw, 
        projectName: raw.projectNumber + " - " + raw.organizationName + " - " + raw.clientProjectNumber,
        userName: raw.userName.replace(/ {2}/g, " ")
    }))
    .filter(raw =>
        (
            (status !== "All")?
                (
                    (status === "Unsubmitted")?
                        raw.workLogStatus === "Created"
                        :
                        (status === "Billed")?
                            raw.billed === "Yes"
                            :
                        raw.workLogStatus === status
                )
                :
                true
        )
        && raw.laborCategory !== "Images" 
        && raw.projectHashKey !== restDayProjectHashKey
        && 
        (filterWords.toLowerCase().split(" ").map(f => JSON.stringify(
            [raw.userName, raw.projectName]
        ).toLowerCase().indexOf(f) > -1).reduce(boolAndReducer, true)) 
    );
    const filteredData = filteredData0.filter(raw => weeknum(raw.startTime) === week).filter(raw => category !== "All"?raw.category === category:true)
    .map(x => ({...x, ...getHours(x)}));
    //---------------------------------------------------------------------
    useEffect(() => {
        let isMounted = true;
        const getData = async () => {
            const formData = new MyFormData();
            //---------------------------------------------------------------
            setShowLoading(true);
            const resWeeks = await myAxios("payroll/readLaborWorkLogsWeek.php", formData);
            if(!isMounted) return;
            setShowLoading(false);
            if(!resWeeks) return;
             //---------------------------------------------------------------
            const dateArray = [];
            const dataMin = new MyDate(resWeeks.data.minTime.replace(/-/g, "/"));
            const dataMax = new MyDate(resWeeks.data.maxTime.replace(/-/g, "/"));
            while(dataMin < dataMax){
                dateArray.push(weeknum(dataMin));
                dataMin.setDate(dataMin.getDate() + 7);
            }
            if(!dateArray.includes(weeknum(dataMax))){
                dateArray.push(weeknum(dataMax));
            }
            setWeeks(dateArray.sort((a, b) => (a < b) ? 1 : -1));
            const currentWeek = weeknum(new MyDate());
            if(!week){
                formData.append("weekStart", getDatefromWeekNum0(currentWeek, 0).toLocaleDateString("fr-CA", {timeZone: "America/Los_Angeles"}));
                formData.append("weekEnd", getDatefromWeekNum0(currentWeek, 7).toLocaleDateString("fr-CA", {timeZone: "America/Los_Angeles"}));
            }else{
                formData.append("weekStart", getDatefromWeekNum0(week, 0).toLocaleDateString("fr-CA", {timeZone: "America/Los_Angeles"}));
                formData.append("weekEnd", getDatefromWeekNum0(week, 7).toLocaleDateString("fr-CA", {timeZone: "America/Los_Angeles"}));
            }
            //---------------------------------------------------------------
            setShowLoading(true);
            const res = await myAxios("invoice/readLaborWorkLogs.php", formData);
            if(!isMounted) return;
            setShowLoading(false);
            if(!res) return;
            //---------------------------------------------------------------
            const currentRawData = res.data;
            if(currentRawData.length){
                const currentData = currentRawData.map(raw => ({...raw, 
                    travelStartTime: raw.travelStartTime.replace(/-/g, "/"),
                    workStartTime: raw.workStartTime.replace(/-/g, "/"),
                    workEndTime: raw.workEndTime.replace(/-/g, "/"),
                    travelEndTime: raw.travelEndTime.replace(/-/g, "/"),
                    startTime: raw.startTime.replace(/-/g, "/"),
                    endTime: raw.endTime.replace(/-/g, "/")
                }));
                setRawData(currentData);
                if(!week){
                    history.push(`/ProjectCalendar/${currentWeek}`);
                }
            }else{
                setRawData(currentRawData);
            }
        }
        getData();
        return () => isMounted = false
    }, [history, week, updateDateTime])
    useEffect(() => {
        document.title = tabTitle;
        return () => {
            document.title = appTitle;
        };
    }, [tabTitle]);
    //---------------------------------------------------------------------
    return (
        <div className = "cssTab">
            <div className = "cssHeader" style = {{background: user.userTheme}}>
                <span>
                    <Resize/>
                    Project Calendar
                    <span data-toggle = "tooltip" title = {"Refreshed on " + updateDateTime} className = "btn btn-primary py-1 ml-4" onClick = {() => setUpdateDateTime(getTimeStamp())}>↻</span>
                </span>                
                <span>
                    <input
                        className = "form-control w-auto"
                        type = "text"
                        onChange = {e => {
                            setFilterWords(e.currentTarget.value.toLowerCase());
                        }}
                    />
                    <img
                        alt = ""
                        src = {magnifierImg}
                    />
                </span>
                <span className = "d-flex align-items-center">
                    <label htmlFor = "week" className = "mb-0">Week:</label>
                    <select
                        id = "week"
                        className = "form-control w-auto ml-2"
                        value = {week}
                        onChange = {e => {
                            history.push(`/ProjectCalendar/${e.currentTarget.value}`);
                        }}
                    >
                        {weeks.map((wk, key) => <option key = {key}>{wk}</option>)}
                    </select>
                </span>
                <span className = "d-flex align-items-center">
                    <label htmlFor = "status" className = "mb-0">Status:</label>
                    <select
                        id = "status"
                        className = "form-control w-auto ml-2"
                        value = {status}
                        onChange = {e => setStatus(e.currentTarget.value)}
                    >
                        <option>All</option>
                        <option>Unsubmitted</option>
                        <option>Submitted</option>
                        <option>Approved</option>
                        <option>Rejected</option>
                        <option>Billed</option>
                    </select>
                </span>
                <span className = "d-flex align-items-center">
                    <label htmlFor = "showTime" className = "mb-0">Show Times:</label>
                    <input
                        id = "showTime"
                        type = "checkbox"
                        className = "cssCheckBox ml-2"
                        onChange = {e => {
                            if(e.currentTarget.checked){
                                setShowTimes(true);
                            }else{
                                setShowTimes(false);
                            }
                        }}
                    />
                </span>
                <span className = "d-flex align-items-center">
                    <label htmlFor = "showHours" className = "mb-0">Show Hours:</label>
                    <input
                        id = "showHours"
                        type = "checkbox"
                        className = "cssCheckBox ml-2"
                        onChange = {e => {
                            if(e.currentTarget.checked){
                                setShowHours(true);
                            }else{
                                setShowHours(false);
                            }
                        }}
                    />
                </span>
                <span className = "d-flex align-items-center">
                    <label htmlFor = "category" className = "mb-0">Category:</label>
                    <select
                        id = "category"
                        className = "form-control w-auto ml-2"
                        value = {category}
                        onChange = {e => {
                            setCategory(e.currentTarget.value);
                        }}
                    >
                        <option>All</option>
                        {departments.map((d, key) => <option key = {key}>{d}</option>)}
                    </select>
                </span>
                <Export
                    filteredData = {filteredData}
                    week = {week}
                />
            </div>
            {showLoading?<div className = "cssContent pb10"><div className = "cssLoading">Loading...</div></div>:
            !filteredData.length?<div className = "cssContent pb10"><div className = "cssLoading">Empty</div></div>:
            <div>
                <div className = "text-center font-weight-bold my-3">
                    <span className = "font-weight-bold mr-4">Status Color Code</span>
                    <span style = {{color:"red", padding: 10, border:"1px solid black", borderRight:"none"}}>Unsubmitted ({filteredData.filter(v=> v.workLogStatus === "Created").length})</span>
                    <span style = {{color:"purple", padding: 10, borderTop:"1px solid black", borderBottom:"1px solid black"}}>Submitted ({filteredData.filter(v=> v.workLogStatus === "Submitted").length})</span>
                    <span style = {{color:"green", padding: 10, borderTop:"1px solid black", borderBottom:"1px solid black"}}>Approved ({filteredData.filter(v=> v.workLogStatus === "Approved").length})</span>
                    <span style = {{color:"pink", padding: 10, borderTop:"1px solid black", borderBottom:"1px solid black"}}>Billed ({filteredData.filter(v=> v.billed === "Yes").length})</span>
                    <span style = {{color:"gray", padding: 10, border:"1px solid black", borderLeft:"none"}}>Rejected ({filteredData.filter(v=> v.workLogStatus === "Rejected").length})</span>
                </div>
                <div className = "overflow-visible">
                    <table className = "table">
                        <thead>
                            <tr className = "stickyHeader">
                                <th>Project Name</th>
                                <th>Monday {week?`(${getDatefromWeekNum(week, 0)})`:null}</th>                    
                                <th>Tuesday {week?`(${getDatefromWeekNum(week, 1)})`:null}</th>
                                <th>Wednesday {week?`(${getDatefromWeekNum(week, 2)})`:null}</th>
                                <th>Thursday {week?`(${getDatefromWeekNum(week, 3)})`:null}</th>
                                <th>Friday {week?`(${getDatefromWeekNum(week, 4)})`:null}</th>
                                <th>Saturday {week?`(${getDatefromWeekNum(week, 5)})`:null}</th>
                                <th>Sunday {week?`(${getDatefromWeekNum(week, 6)})`:null}</th>
                            </tr>
                            </thead>
                            <tbody> 
                            {filteredData.map(raw => raw.projectHashKey).filter(onlyUnique)
                            .map(raw => filteredData.filter(r => r.projectHashKey === raw)).map((v, key) =>
                                <tr key = {key}>
                                    <td>
                                        <Link className = "font-weight-bold" to = {`/Projects/${v[0].projectHashKey}`}>
                                            {v[0].projectNumber} - {v[0].organizationName} - {v[0].clientProjectNumber}
                                        </Link>
                                        {showHours?
                                        <div>
                                            <div className = "mr-5">
                                                <span className = "font-weight-bold mr-2">Work + Travel:</span>
                                                {round(filteredData.filter(raw => raw.projectHashKey === v[0].projectHashKey).map(raw => raw.portal).reduce(numberReducer, 0), 2)}
                                            </div>
                                            <div>
                                                <span className = "font-weight-bold mr-2">Work:</span>
                                                {round(filteredData.filter(raw => raw.projectHashKey === v[0].projectHashKey).map(raw => raw.withoutTravel).reduce(numberReducer, 0), 2)}
                                            </div>
                                        </div>:null}
                                    </td>
                                    {weekIndexes.map((num, numi) => <td key = {numi}>
                                        <ul>
                                            {v.filter(vx => (new Date(vx.startTime.substring(0, 10).replace(/-/g, "/"))).getDay() === num).map(vx => vx.workInstructionHashKey).filter(onlyUnique)
                                            .map(vv => filteredData.filter(vx => (vx.workInstructionHashKey === vv)))
                                            .map((vv, vvi) => 
                                            <li key = {vvi}>
                                                <Link className = "font-weight-bold" to = {`/Projects/${vv[0].projectHashKey}/WorkInstructions/${vv[0].workInstructionHashKey}`}>
                                                    {
                                                        vv[0].startTime.substring(0, 10) === vv[0].endTime.substring(0, 10)?
                                                            vv[0].startTime.substring(11, 16) === "00:00" && vv[0].endTime.substring(11, 16) === "00:00"?
                                                            `All Day`
                                                            :
                                                            `${vv[0].startTime.substring(11, 16)} ~ ${vv[0].endTime.substring(11, 16)}`
                                                        :
                                                        vv[0].startTime.substring(11, 16) === "00:00" && vv[0].endTime.substring(11, 16) === "00:00"?
                                                        `Overnight`
                                                        :
                                                        `${vv[0].startTime.substring(11, 16)} ~ ${vv[0].endTime.substring(0, 16)}`
                                                    }
                                                    {vv[0].billed === "Yes"?<span style = {{color: "pink"}}>&nbsp;Billed</span>:null}
                                                </Link>
                                                <ul>{vv.map((vvv, vvvi) => 
                                                    <li key = {vvvi}>
                                                        <Link to = {`/Projects/${vvv.projectHashKey}/WorkInstructions/${vvv.workInstructionHashKey}/WorkLogs/${vvv.workLogHashKey}`}>
                                                            <span className = "font-weight-bold" style = {{color: simpleStatusColorCode[vvv.workLogStatus]}}>
                                                                <span className = "mr-2 text-info">{vvv.laborCategory}</span>
                                                                {vvv.userName}
                                                                <span className = "text-secondary ml-2">{vvv.truckNumber?`truck ${vvv.truckNumber}`:""}</span>
                                                            </span>
                                                        </Link>
                                                        <ul>
                                                            {showTimes?<>
                                                            <li>
                                                                <span className = "font-weight-bold mr-2">Travel Start:</span>
                                                                {vvv.travelStartTime !== defaultEmptyDateTime?(
                                                                    (new Date(vvv.travelStartTime.substring(0, 10).replace(/-/g, "/"))).getDay() === num?
                                                                    vvv.travelStartTime.substring(10, 16):
                                                                    vvv.travelStartTime.substring(0, 16)
                                                                ):null}
                                                            </li>
                                                            <li>
                                                                <span className = "font-weight-bold mr-2">Work Start:</span>
                                                                {vvv.workStartTime !== defaultEmptyDateTime?(
                                                                    (new Date(vvv.workStartTime.substring(0, 10).replace(/-/g, "/"))).getDay() === num?
                                                                    vvv.workStartTime.substring(10, 16):
                                                                    vvv.workStartTime.substring(0, 16)
                                                                ):null}
                                                            </li>
                                                            <li> 
                                                                <span className = "font-weight-bold mr-2">Work End:</span>
                                                                {vvv.workEndTime !== defaultEmptyDateTime?(
                                                                    (new Date(vvv.workEndTime.substring(0, 10).replace(/-/g, "/"))).getDay() === num?
                                                                    vvv.workEndTime.substring(10, 16):
                                                                    vvv.workEndTime.substring(0, 16)
                                                                ):null}
                                                            </li>
                                                            <li>
                                                                <span className = "font-weight-bold mr-2">Travel End:</span>
                                                                {vvv.travelEndTime !== defaultEmptyDateTime?(
                                                                    (new Date(vvv.travelEndTime.substring(0, 10).replace(/-/g, "/"))).getDay() === num?
                                                                    vvv.travelEndTime.substring(10, 16):
                                                                    vvv.travelEndTime.substring(0, 16)
                                                                ):null}
                                                            </li>
                                                            </>:null}
                                                            {showHours?<>
                                                            {vvv.workLogStatus !== "Created"?<>
                                                                <li>
                                                                    <span className = "font-weight-bold mr-2">Work + Travel:</span>
                                                                    {vvv.portal}
                                                                </li>
                                                                <li>
                                                                    <span className = "font-weight-bold mr-2">Work:</span>
                                                                    {vvv.withoutTravel}
                                                                </li>
                                                            </>:null}
                                                            </>:null}
                                                        </ul>
                                                    </li>)}
                                                </ul>   
                                            </li>)}
                                        </ul>
                                    </td>)}
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>}
        </div>
    )
}